export default "__VITE_ASSET__Dp2dHhxG__"